<template>
  <b-card class="p-0 h-100">
    <b-row class="p-0 h-100">
      <b-col class="border-right h-100" cols="4">
        <b-row class="align-items-center border-bottom mb-2" style="height: 60px">
          <b-col cols="6">
            <h5 class="m-0 p-0 text-primary">{{ rows }} Emails</h5>
          </b-col>
          <b-col v-if="!add" class="d-flex justify-content-end" cols="6">
            <h-b-action
              v-if=""
              :positive="false"
              icon="bx bx-plus"
              text="Ajouter"
              @click.native="handleAdd"
            ></h-b-action>
          </b-col>
        </b-row>
        <b-row>
          <h-f-design-search-field v-model="searchInput" class="w-100 px-2 mb-2"> </h-f-design-search-field>
        </b-row>
        <div class="pt-2" style="height: 78%; overflow: scroll">
          <b-row
            v-for="(email, index) in emails"
            :key="index"
            :class="{ selected: email === actualEmail, 'border-bottom': index !== emails.length - 1 }"
            class="p-3 mx-1 cursor-pointer"
            @click="handleSelectMail(index)"
          >
            <b-col cols="12">
              <b-row>
                <h6 class="p-0 m-0">
                  {{ email.title }}
                </h6>
              </b-row>
              <b-row>
                <p class="p-0 m-0">
                  {{ email.object }}
                </p>
              </b-row>
              <b-row class="d-flex justify-content-end">
                <p class="p-0 m-0 text-semi-light">
                  {{ email.created_at | formatDate }}
                </p>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="d-flex justify-content-center">
            <i
              v-if="loadedMode && emails.length < rows"
              class="bx bx-plus-circle bx-md text-primary cursor-pointer mt-3"
              @click="getMoreEmails"
            ></i>
            <h-e-spinner v-if="!loadedMode" size="sm"></h-e-spinner>
          </b-row>
        </div>
      </b-col>
      <b-col v-if="!add && actualEmail && loaded" class="h-100" cols="8">
        <b-row class="align-items-center border-bottom" style="height: 60px">
          <b-col class="pl-3" cols="4">
            <h6 class="m-0 p-0">
              {{ actualEmail.title }}
            </h6>
          </b-col>
          <b-col cols="3">
            <h6 class="m-0 p-0">{{ formatService }} - {{ formatCategory }}</h6>
          </b-col>
          <b-col cols="3">
            <p class="m-0 p-0 text-semi-light">
              {{ actualEmail.created_at | formatDateHour }}
            </p>
          </b-col>
          <b-col class="d-flex justify-content-between" cols="2">
            <h-b-action-rounded icon="bx bx-edit-alt" @click.native="handleEditEmail"></h-b-action-rounded>
            <h-b-action-rounded icon="bx bx-copy" @click.native="duplicateEmail"></h-b-action-rounded>
            <!--            <h-b-action-rounded icon="bx bx-trash-alt" @click.native="deleteEmail"></h-b-action-rounded>-->
          </b-col>
        </b-row>
        <b-row class="pl-3 pt-3" style="height: 78%; overflow: scroll">
          <b-col cols="12">
            <b-row>
              <h5 class="p-0 m-0">
                {{ actualEmail.object }}
              </h5>
            </b-row>
            <b-row>
              <div class="mt-2" v-html="actualEmail.text"></div>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="add" class="h-100" cols="8">
        <b-row class="align-items-center border-bottom" style="height: 60px">
          <b-col class="pl-3" cols="6">
            <h-f-fields
              v-model="formEmail.title"
              :invalid="$v.formEmail.title.$error"
              :required="!$v.formEmail.title.required"
              :submitted="submitted"
              placeholder="Titre du mail ..."
            ></h-f-fields>
          </b-col>
          <b-col cols="3" v-if="!defaultService">
            <h-f-fields
              v-model="actualService"
              :base-url="notifUrl"
              :text-values="['name']"
              fields="id,name"
              input-type="search-field"
              placeholder="Choisir un service ..."
              ressource="services"
            ></h-f-fields>
          </b-col>
          <b-col cols="3" v-else class="d-flex justify-content-center">
            <h6 class="m-0 p-0">
              {{ defaultService }}
            </h6>
          </b-col>
          <b-col cols="3" v-if="!defaultCategory">
            <h-f-fields
              v-if="actualService && !modify"
              v-model="formEmail.category"
              :base-url="notifUrl"
              :fields="'id,label' + '&service=' + this.actualService"
              :invalid="$v.formEmail.category.$error"
              :required="!$v.formEmail.category.required"
              :submitted="submitted"
              :text-values="['label']"
              input-type="search-field"
              placeholder="Choisir une catégorie ..."
              ressource="emails/categories"
            ></h-f-fields>
            <h-f-fields
              v-if="actualService && modify"
              v-model="formEmail.category.id"
              :base-url="notifUrl"
              :fields="'id,label' + '&service=' + this.actualService"
              :invalid="$v.formEmail.category.$error"
              :required="!$v.formEmail.category.required"
              :submitted="submitted"
              :text-values="['label']"
              input-type="search-field"
              placeholder="Choisir une catégorie ..."
              ressource="emails/categories"
            ></h-f-fields>
          </b-col>
          <b-col cols="3" v-else class="d-flex justify-content-center">
            <h6 class="m-0 p-0">
              {{ defaultCategory }}
            </h6>
          </b-col>
        </b-row>
        <b-row class="pl-3 pt-3" style="height: 78%; overflow: scroll">
          <b-col cols="12">
            <b-row>
              <h-f-fields
                v-model="formEmail.object"
                :invalid="$v.formEmail.object.$error"
                :required="!$v.formEmail.object.required"
                :submitted="submitted"
                class="w-75"
                label="Objet"
              ></h-f-fields>
            </b-row>
            <b-row>
              <h-f-fields
                v-model="formEmail.text"
                :invalid="$v.formEmail.text.$error"
                :required="!$v.formEmail.text.required"
                :submitted="submitted"
                class="w-75"
                input-type="ckeditor"
                label="Contenu"
              ></h-f-fields>
            </b-row>
            <b-row v-if="formEmail.category" class="mt-3">
              <b-dropdown variant="primary">
                <template v-slot:button-content>
                  Choisir une donnée
                  <i class="mdi mdi-chevron-down"></i>
                </template>
                <b-dropdown-item v-for="(variable, index) in variables" :key="index" @click="addVariable(variable.key)">
                  {{ variable.label }}
                </b-dropdown-item>
              </b-dropdown>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="d-flex justify-content-end mx-5 mb-5 mt-4">
          <h-b-action
            :positive="false"
            text="Annuler"
            @click.native="
              add = false
              submitted = false
              modify = false
            "
          >
          </h-b-action>
          <h-b-action
            v-if="!modify && loadedPost"
            :positive="true"
            class="ml-5"
            text="Ajouter"
            @click.native="createEmail"
          >
          </h-b-action>
          <h-b-action
            v-if="modify && loadedPost"
            :positive="true"
            class="ml-5"
            text="Modifier"
            @click.native="editEmail"
          >
          </h-b-action>
          <h-e-spinner v-if="!loadedPost" class="m-0 w-25" size="sm"></h-e-spinner>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { APIRequest, FunctionHelpers, TemplateEmail } from '@/node-sdk'
import moment from 'moment'
import 'moment/locale/fr' // without this line it didn't work
moment.locale('fr')
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'template-email',

  props: {
    defaultMail: {
      type: String,
      default: null,
    },
    value: String,
    limitToService: {
      type: String,
      default: '',
    },
    limitToCategory: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      rows: 0,
      emails: [],
      searchInput: null,
      selected: true,
      actualEmail: null,
      page: 1,
      add: false,
      loadedMode: true,
      formEmail: TemplateEmail.get_form(),
      submitted: true,
      actualService: null,
      modify: false,
      notifUrl: process.env.VUE_APP_NOTIFICATIONS_API,
      services: [],
      categories: [],
      serviceChoices: [],
      categoryChocies: [],
      loadedPost: true,
      loaded: false,
      variables: [],
      defaultService: null,
      defaultCategory: null,
    }
  },

  validations: {
    formEmail: {
      title: { required },
      category: { required },
      object: { required },
      text: { required },
    },
  },

  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },

    formatDateHour(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
  },

  watch: {
    searchInput: function () {
      this.getEmails()
    },

    'formEmail.category': async function () {
      if (!this.modify) {
        this.variables = this.categories.find((category) => category.id === this.formEmail.category).variables
      } else {
        this.variables = this.categories.find((category) => category.id === this.formEmail.category.id).variables
      }
    },

    value: async function () {
      await this.handleDefaultValue()
    },
  },

  async mounted() {
    await this.getEmails()
    await this.getServices()
    await this.getCategories()
    await this.handleDefaultValue()
    this.loaded = true
  },

  methods: {
    async getEmails() {
      this.emails = []
      let request = this.formatRequest()
      ;[this.emails, this.rows] = await APIRequest.get_with_request(
        process.env.VUE_APP_NOTIFICATIONS_API,
        'emails/templates',
        request,
      )
      if (this.emails.length > 0) {
        this.actualEmail = this.emails[0]
      }
    },

    async getServices() {
      ;[this.services] = await APIRequest.get_with_request(process.env.VUE_APP_NOTIFICATIONS_API, 'services', '')
      let formatedServices = []
      if (this.limitToService !== '') {
        for (let i = 0; i < this.services.length; i++) {
          if (this.services[i].id === this.limitToService) {
            formatedServices.push(this.services[i])
            this.defaultService = this.services[i].name
          }
        }
      }
      this.serviceChoices = FunctionHelpers.formatModelSelect(formatedServices, ['name'], 'id')
    },

    async getCategories() {
      ;[this.categories] = await APIRequest.get_with_request(
        process.env.VUE_APP_NOTIFICATIONS_API,
        'emails/categories',
        '?expand=variables',
      )
      let formatedCategories = []
      if (this.limitToCategory !== '') {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i].id === this.limitToCategory) {
            formatedCategories.push(this.categories[i])
            this.defaultCategory = this.categories[i].label
          }
        }
      }
      this.categoryChocies = FunctionHelpers.formatModelSelect(formatedCategories, ['label'], 'id')
    },

    async getMoreEmails() {
      this.loadedMode = false
      this.page++
      let emails = []
      let request = this.formatRequest()
      ;[emails, this.rows] = await APIRequest.get_with_request(
        process.env.VUE_APP_NOTIFICATIONS_API,
        'emails/templates',
        request,
      )
      this.emails = this.emails.concat(emails)
      this.loadedMode = true
    },

    async handleDefaultValue() {
      if (this.value) {
        let defaultMailIndex = this.emails.findIndex((email) => email.id === this.value)
        if (defaultMailIndex === -1) {
          let email = await APIRequest.get_by_id(
            process.env.VUE_APP_NOTIFICATIONS_API,
            'emails/templates',
            this.value + '?expand=category.service',
          )
          this.emails.unshift(email)
          this.actualEmail = this.emails[0]
        } else {
          this.actualEmail = this.emails[defaultMailIndex]
        }
      }
      this.$emit('input', this.actualEmail.id)
    },

    handleAdd() {
      this.add = true
      this.modify = false
      if (this.limitToCategory !== '') {
        this.formEmail.category = this.limitToCategory
      }
      if (this.limitToService !== '') {
        this.actualService = this.limitToService
      }
    },

    async createEmail() {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        FunctionHelpers.formErrorModal()
      } else {
        this.loadedPost = false
        let email = await APIRequest.create(process.env.VUE_APP_NOTIFICATIONS_API, 'emails/templates', this.formEmail)
        email.category = {
          id: email.category,
          name: this.categories.find((category) => (category.id = email.category)).label,
        }
        email.category.service = {
          id: this.actualService,
          name: this.categories.find((service) => (service.id = this.actualService)).name,
        }
        this.emails.unshift(email)
        this.actualEmail = this.emails[0]
        this.initForm()
        this.rows++
      }
    },

    initForm() {
      this.add = false
      this.modify = false
      this.formEmail = TemplateEmail.get_form()
      this.submitted = false
      this.loadedPost = true
      this.actualService = null
    },

    async deleteEmail() {
      let result = await FunctionHelpers.confirmModal('Supprimer')
      if (result.value) {
        await APIRequest.delete(process.env.VUE_APP_NOTIFICATIONS_API, 'emails/templates', this.actualEmail.id)
        let actualEmailIndex = this.emails.findIndex((email) => email.id === this.actualEmail.id)
        this.$delete(this.emails, actualEmailIndex)
        this.actualEmail = this.emails[0]
        this.rows--
      }
    },

    async duplicateEmail() {
      let tempMail = Object.assign({}, this.actualEmail)
      tempMail.category = tempMail.category.id
      let newMail = await APIRequest.create(process.env.VUE_APP_NOTIFICATIONS_API, 'emails/templates', tempMail)
      newMail.category = this.actualEmail.category
      this.emails.unshift(newMail)
      this.actualEmail = this.emails[0]
      this.rows++
    },

    async editEmail() {
      this.submitted = true
      this.loadedPost = false
      this.$v.$touch()
      if (this.$v.$invalid) {
        FunctionHelpers.formErrorModal()
      } else {
        let tempMail = Object.assign({}, this.formEmail)
        tempMail.category = tempMail.category.id
        await APIRequest.edit(process.env.VUE_APP_NOTIFICATIONS_API, 'emails/templates', tempMail.id, tempMail)
        this.initForm()
      }
    },

    formatRequest() {
      let request = `?page=${this.page}&category=${this.limitToCategory}&expand=category.service`
      if (this.searchInput !== '' && this.searchInput !== null) {
        request += `&search=${this.searchInput}`
      }
      return request
    },

    handleSelectMail(index) {
      this.actualEmail = this.emails[index]
      this.$emit('input', this.actualEmail.id)
    },

    handleEditEmail() {
      this.modify = true
      this.formEmail = this.actualEmail
      this.actualService = this.actualEmail.category.service.id
      this.add = true
    },

    addVariable(key) {
      let email_length = this.formEmail.text.length
      this.formEmail.text =
        this.formEmail.text.slice(0, email_length - 4) + key + this.formEmail.text.slice(email_length - 4)
    },
  },

  computed: {
    formatService() {
      return this.services.find((service) => service.id === this.actualEmail.category.service.id).name
    },

    formatCategory() {
      return this.categories.find((category) => category.id === this.actualEmail.category.id).label
    },
  },
}
</script>

<style scoped>
.selected {
  background: #f9f9ff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}
</style>
